import { useMutation } from "react-query";
import { AllocateSubscription } from "../services/StructureNote";

function useSendAgreements() {
  return useMutation(["sendAgreement"], AllocateSubscription);
}

export default useSendAgreements;
